// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"350cca15","49":"0ae2ae5d","297":"05b2de4c","731":"decf9942","811":"b6a579e7","886":"a0fc58c4","914":"3f15d9b3"}[chunkId] + ".chunk.js";
};